import { CSSObject } from "@emotion/react";

export const containerCSS: CSSObject = {
  width: "100%",
  display: "flex",
  gap: 16,
  flexDirection: "column",
  backgroundColor: "#FFECCF",
  padding: 16,
  borderRadius: 8,
};
